import { Flex } from "antd";
import Layout from "../components/layout";

const NotFound = () => {
  return (
    <Layout>
      <Flex vertical align="center" className="py-[3rem] pb-[9rem]">
        <h1 className="text-[15rem] font-bold mb-0">
          404
        </h1>
        <p className="text-[4rem] mb-0">
          Page Not Found
        </p>
      </Flex>
    </Layout>
  );
};

export default NotFound;
